import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useContext,
} from "react";
import { AgGridReact } from "ag-grid-react";
import {
  getAllSalesOrder,
  getInvPDFObject,
  getPatientAdvPayments,
  getPatientInvoices,
  getReceiptPDFObject,
} from "./ERPActions/erpActions";
import { fetchInvoices } from "./FinancialCardUpdate";
import {
  ERP_VISIT_FIN_SUMMARY_TYPE_INV,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
  ERP_VISIT_FIN_SUMMARY_TYPE_PAYMENTS,
  ERP_INVOICE_WORKING_DATA_TYPE_SO_GENERATE_INVOICE,
  MONTH_SHORT_NAME,
  ERP_INVOICE_WORKING_DATA_TYPE_VIEW_INVOICE,
  AG_GRID_REACT_MIN_ROW_HEIGHT,
  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE,
  COMPONENT_WISE_AG_GRID_PAGINATION,
  ERP_VISIT_FIN_SUMMARY_TYPE_REFUND_PAYMENTS,
  HMS_REPORT_TEMPLATE_TYPE,
  COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT,
  PAGE_MODE,
  BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS,
  PATIENT_VISIT_TYPE,
  INVOICE_DETAILS_LABLE,
  INVOICE_DETAILS_LABEL,
  MASTER_LOCATION_DATA_LOCATION_KEY,
} from "../../core/constants/erpConstants";
import { DataContext } from "./ERPBilling";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { generateBillHtml } from "../printConvertion/DocumentConvert";
import HeaderFooterComponent from "../printConvertion/HeaderAndFooter";
import { useOrganization } from "../../configurations/OrganizationContext";
import { helperServices } from "../../shared/helper";
import { useSelector } from "react-redux";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreOptionsMenu from "./MoreOptionsMenu";

import {
ORG_CODES
} from "../../shared/constants";

const copyTextToClipboard = async (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);

  try {
    textArea.focus();
    textArea.select();
    if (!document.execCommand("copy")) {
      throw new Error("Copy failed");
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

export default function ERPVisitFinancialSummary({
  onGenerateInvoice,
  ...props
}) {
  const org = useOrganization();
  const { prodcutSelected, setProductSelected } = useContext(DataContext);

  const [balanceAmount, setBalanceAmount] = useState(0.0);
  const [totalAdvPaid, setTotalAdvPaid] = useState(0.0);
  const [totalFinAmtSummary, setTotalFinAmtSummary] = useState(null);
  const [selectedLocationDetail, setSelectedLocationDetail] = useState(
    props.selectedLocationDetails,
  );
  const [rowData, setRowData] = useState([]);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [totalBillAmt, setTotalBillAmt] = useState(0.0);
  const [finSummary, setFinSummary] = useState();
  const [onClearInvoiceStart, setOnClearInvoiceStart] = useState(true);
  const [printdata, setPrintData] = useState("");
  const [triggerAction, setTriggerAction] = useState("");
  const [isPrintDisable, setIsPrintDisable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isBackgroundTransparent, setIsBackgroundTransparent] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const patientBasicInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic,
  );
  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails,
  );
  const getLocationId = () => {
    console.log("locationDetails : ", selectedLocationDetail);
    if (selectedLocationDetail && selectedLocationDetail.locationDetails) {
      return selectedLocationDetail.locationDetails.erpLocationDetails[0]
        .locationid;
    }
  };

  // const [showDiscount, setShowDiscount] = useState(
  //     org?.orgCode ===
  // );

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Main",
      field: "patientId",
      colId: "patientId",
      sortable: true,
      filter: true,
      tooltipField: "Main",
    },
    {
      headerName: "IP/OP No",
      field: "ipopnumber",
      // flex: 0.40,
      valueGetter: (params) => {
        return params.data.ipopnumber;
      },
      cellRenderer: (params) => {
        if (!params.value) return "";

        const isClickable = typeof params?.context?.onRowClick === "function";

        return isClickable
          ? `<span class="visit-link">${params.value}</span>`
          : `<span class="visit-link-disabled">${params.value}</span>`;
      },
      onCellClicked: (params) => {
        if (params.event.target.classList.contains("visit-link")) {
          if (typeof props.onRowClick === "function") {
            props.onRowClick({
              patientId: params.data.patientId,
              visitId: params.data.visitId,
            });
          }
        }
      },
      colId: "invoiceId",
      sortable: true,
      filter: true,
      tooltipField: "IP/OP Number",
    },

    {
      headerName: "Patient Name",
      field: "patientFullName",
      colId: "patientFullName",
      sortable: true,
      filter: true,
      tooltipField: "Patient Full Name",
    },
    {
      headerName: "Invoice Type",
      field: "hmsInvoiceType",
      colId: "hmsInvoiceType",
      // hide: true,
      sortable: true,
      filter: true,
      tooltipField: "Invoice Type",
      hide: org?.orgCode?.toLowerCase() !== "mnh",
    },
    {
      headerName: "Invoice/Receipt ID",
      field: "invoiceId",
      colId: "invoiceId",
      sortable: true,
      filter: true,
      tooltipField: "Invoice ID",
      cellStyle: (params) =>
        params.value
							? { color: "#1976d2", cursor: "pointer" }
          : {},
      onCellClicked: async (params) => {
        if (!params.value) return;

        const showMessageStrip =
          params.context && params.context.showMessageStrip;
        try {
          await copyTextToClipboard(String(params.value));
          if (typeof showMessageStrip === "function") {
            showMessageStrip("Invoice number copied", "success");
          }
        } catch (error) {
          if (typeof showMessageStrip === "function") {
            showMessageStrip("Unable to copy invoice number", "error");
          }
        }
      },
    },
    {
      headerName: "Invoice Date",
      field: "invoiceDate",
      colId: "invoiceDate",
      sortable: true,
      filter: true,
      tooltipField: "Invoice Generation Date",
    },
    {
      headerName: "Location",
      field: "location",
      colId: "location",
      sortable: true,
      filter: true,
      tooltipField: "Location",
    },
    {
      headerName: "LocationId",
      field: "locationId",
      colId: "locationId",
      hide: true,
      sortable: true,
      filter: true,
      filterParams: {
        valueFormatter: getLocationId,
      },
      tooltipField: "Location",
    },

    // ✅ Conditional columns
    ...(props.pageMode == PAGE_MODE.SINGLE_INVOICE
      ? [
          {
            headerName: `Invoice Total ₹ ${balanceAmount}`,
            autoHeaderHeight: true,
            children: [
              {
                columnGroupShow: "open",
                field: "billAmt",
                colId: "billAmt",
                headerName: "Bill Amount",
                sortable: true,
                filter: true,
                cellStyle: { textAlign: "right" },
              },
              {
                columnGroupShow: "open",
                field: "receivedAmt",
                colId: "receivedAmt",
                headerName: "Received Amount",
                sortable: true,
                filter: true,
                cellStyle: { textAlign: "right" },
              },
              {
                columnGroupShow: "open",
                field: "discountAmt",
                colId: "discountAmt",
                headerName: "Discount Amount",
                sortable: true,
                filter: true,
                cellStyle: { textAlign: "right" },
                // hide: org?.orgCode==="MNH",
              },
              {
                columnGroupShow: "open",
                field: "paymentAmt",
                colId: "paymentAmt",
                headerName: "Payable Amount",
                sortable: true,
                filter: true,
                cellStyle: { textAlign: "right" },
              },
              {
                columnGroupShow: "open",
                field: "generatedBy",
                colId: "generatedBy",
                headerName: "Generated By",
                sortable: true,
                filter: true,
                cellStyle: { textAlign: "left" },
                // hide: org?.isDiscount?.display,
              },
            ],
            sortable: true,
            filter: true,
            marryChildren: true,
            tooltipField: "Balance",
          },
        ]
      : [
          {
            field: "billAmt",
            colId: "billAmt",
            headerName: "Bill Amount",
            sortable: true,
            filter: true,
            cellStyle: { textAlign: "right" },
          },
          {
            field: "receivedAmt",
            colId: "receivedAmt",
            headerName: "Received Amount",
            sortable: true,
            filter: true,
            cellStyle: { textAlign: "right" },
          },
          {
            field: "discountAmt",
            colId: "discountAmt",
            headerName: "Discount Amount",
            sortable: true,
            filter: true,
            cellStyle: { textAlign: "right" },
          },
          {
            field: "paymentAmt",
            colId: "paymentAmt",
            headerName: "Payable Amount",
            sortable: true,
            filter: true,
            cellStyle: { textAlign: "right" },
          },
        ]),

    {
      headerName: "Action",
      field: "action",
      colId: "action",
      sortable: true,
      filter: true,
      flex: 1.5,
      // cellStyle: { alignItems: "right" },
      cellRenderer: "ActionRenderer",
      tooltipField: "Action",
    },
  ]);

  // First, create an ActionRenderer component at the top of your file, after the imports
  const ActionRenderer = (cellProps) => {
    console.log("ActionRenderer: ", cellProps);
    console.log("ActionRenderer props : ", props);
    console.log("ActionRenderer:patientBasicInfo : ", patientBasicInfo);

    // Compute isMenuMoreOptionDisable directly from data instead of using state
    // This prevents infinite re-render loops caused by calling setState during render
    const isMenuMoreOptionDisable =
      cellProps.data.type !== ERP_VISIT_FIN_SUMMARY_TYPE_INV;

    let paymentAmount = 0;

    if (cellProps.data.paymentAmt) {
      paymentAmount = cellProps.data.paymentAmt.replace("₹ ", "");
    }
    console.log("ActionRenderer paymentAmount : ", paymentAmount);
    const handleViewInvoice = async () => {
      if (props.pageMode == PAGE_MODE.SINGLE_INVOICE) {
        console.log("handle View Invoice clicked for row:", cellProps);
        // Add your edit logic here
        const rowData = {
          ...cellProps.data,
          dataType: ERP_INVOICE_WORKING_DATA_TYPE_VIEW_INVOICE,
        };

        // Update the productSelected state in ERPServiceList
        setProductSelected(rowData);
      } else if (props.pageMode == PAGE_MODE.ALL_INVOICELIST) {
        console.log("handle View Invoice clicked for row:", cellProps);
        let ticketId = cellProps?.data?.ticketId;
        let customerId = null;
        let visitId = null;
        let reportType = null;
        let locationIds = null;
        let templateReportType = HMS_REPORT_TEMPLATE_TYPE.SINGLE_INVOICE;
        let actionType = "preview";
        const printPDF = await getInvPDFObject(
          ticketId,
          visitId,
          customerId,
          reportType,
          locationIds,
        );
        const data = await generateBillHtml(
          printPDF.hmsInvReportDTOList,
          templateReportType,
          org?.orgCode,
        );
        console.log("Generated HTML Data: ", data);

        setPrintData(data);
        setTriggerAction(actionType);
      }
    };

    const handlePrintInvoice = async (cellProps, actionType, rowDataType) => {
      setIsPrintDisable(true);
      console.log("print inv: ", cellProps.data, " \nactionType : ", actionType, "\n rowDataType : ", rowDataType);
      let templateReportType = null;
      if (rowDataType === ERP_VISIT_FIN_SUMMARY_TYPE_PAYMENTS) {
        templateReportType = HMS_REPORT_TEMPLATE_TYPE.RECEIPT;
        handleRecieptPrint(cellProps.data, templateReportType, actionType);
      } else if (rowDataType === ERP_VISIT_FIN_SUMMARY_TYPE_REFUND_PAYMENTS) {
        templateReportType = HMS_REPORT_TEMPLATE_TYPE.REFUND_VOUCHER;
        handleRecieptPrint(cellProps.data, templateReportType, actionType);
      } else if (rowDataType === ERP_VISIT_FIN_SUMMARY_TYPE_INV) {
        templateReportType = HMS_REPORT_TEMPLATE_TYPE.SINGLE_INVOICE;
        handleInvoiceReport(cellProps.data, templateReportType, actionType);
      }
    };

    const handleRecieptPrint = async (
      rowData,
      templateReportType,
      actionType,
    ) => {
      console.log("handleRecieptRefund ", templateReportType, org?.orgCode);

      console.log("paymentDetails: ", rowData, props);
      // const receiptId = await rowData.invoiceId
      //   .replace(ERP_INVOICE_RECEIPT_REFUND_PREFIX.REFUND_PREFIX, "")
      //   .replace(ERP_INVOICE_RECEIPT_REFUND_PREFIX.RECEIPT_PREFIX, "");

      const receiptId = rowData.voucherId;

      console.log(
        "patientId: ",
        rowData.patientId,
        "visitId: ",
        rowData.visitId,
      );
      const receptData = await getReceiptPDFObject(
        receiptId,
        rowData.visitId,
        rowData.patientId,
        rowData.paymentDetails,
      );
      console.log("receptData: ", receptData);

      receptData.regNo = rowData.patientId;

      console.log("recept data after adding main: ", receptData);

      const data = await generateBillHtml(
        receptData,
        templateReportType,
        org?.orgCode,
      );
      console.log("Generated HTML Data: ", data);
      setPrintData(data);
      setTriggerAction(actionType);
      setIsPrintDisable(false);
    };

    const handleInvoiceReport = async (
      rowData,
      templateReportType,
      actionType,
    ) => {
      let ticketId = rowData.ticketId;
      let customerId = null;
      let visitId = null;
      let reportType = null;
      let locationIds = [rowData.locationId];
      const printPDF = await getInvPDFObject(
        ticketId,
        visitId,
        customerId,
        reportType,
        locationIds,
      );
      const data = await generateBillHtml(
        printPDF.hmsInvReportDTOList,
        templateReportType,
        org?.orgCode,
      );
      console.log("Generated HTML Data: ", data);
      setPrintData(data);
      setTriggerAction(actionType);
      setIsPrintDisable(false);
    };

    const handleGenerateInvoice = () => {
      console.log("Delete clicked for row: ", cellProps.data);
      console.log("Delete clicked for row data : ");
      // Add your delete logic here
      const rowData = {
        ...cellProps.data,
        dataType: ERP_INVOICE_WORKING_DATA_TYPE_SO_GENERATE_INVOICE,
      };
      console.log("data productSelected: ", rowData);

      // Update the productSelected state in ERPServiceList
      setProductSelected(rowData);
    };

    //paynow towards the invoice
    const handleInvoicePayment = (cellProps) => {
      console.log("handleInvoicePayment method is called: ", cellProps);
      try {
        // Prefer a numeric field if present, else parse from formatted string
        // let payableAmount = 0;
        // if (typeof cellProps.data.paymentAmt === 'number') {
        //     payableAmount = cellProps.data.paymentAmt;
        // } else if (typeof cellProps.data.paymentAmt === 'string') {
        //     const parsed = Number(String(cellProps.data.paymentAmt).replace(/[^0-9.\-]/g, ''));
        //     payableAmount = isNaN(parsed) ? 0 : parsed;
        // }
        // Invoke parent handler to open ERPPayment in outstanding-bill mode
        // if (onClearInvoiceStart) {
        props.onClearInvoiceStart({
          amount: paymentAmount,
          rowData: cellProps.data,
        });
        // }
      } catch (e) {
        console.error("Error while preparing invoice payment details:", e);
      }
    };

    const handleMoreOptionMenuClose = (closeType) => {
      if ("reloadpage" === closeType) {
        setIsReload((prev) => !prev);
      }
    };

    return (
      // gap: '30px',
      <div className="d-flex align-items-center ms-2 gap-1 icon-action-row justify-content-end">
        {/* Approve */}
        {props.pageMode &&
          props.pageMode !== PAGE_MODE.ALL_INVOICELIST &&
          paymentAmount &&
          paymentAmount != 0 && (
            <div
              className="icon-btn text-success"
              title="Pay Now"
              onClick={() => handleInvoicePayment(cellProps)}
            >
              <i className="material-icons">check</i>
            </div>
          )}

        {/* Invoice Actions */}
        {cellProps.data.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV && (
          <>
            <div
              className="icon-btn text-dark"
              title="View Invoice"
              onClick={() => handleViewInvoice(cellProps)}
            >
              <i className="material-icons">visibility</i>
            </div>
          </>
        )}

        {/* Print Invoice/Receipt */}
        {(cellProps.data.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV ||
          cellProps.data.type === ERP_VISIT_FIN_SUMMARY_TYPE_PAYMENTS ||
          cellProps.data.type ===
            ERP_VISIT_FIN_SUMMARY_TYPE_REFUND_PAYMENTS) && (
          <>
            <div
              className="icon-btn text-dark"
              title={isPrintDisable ? "Disabled" : "Print Invoice"}
              onClick={
                !isPrintDisable
                  ? () =>
                      handlePrintInvoice(
                        cellProps,
                        "print",
                        cellProps.data.type,
                      )
                  : undefined
              }
              style={{
                pointerEvents: isPrintDisable ? "none" : "auto", // disables click
                opacity: isPrintDisable ? 0.5 : 1, // shows a dimmed style
                cursor: isPrintDisable ? "not-allowed" : "pointer",
              }}
            >
              <i className="material-icons">print</i>
            </div>
          </>
        )}

        {/* Generate Invoice */}
        {cellProps.data.type === ERP_VISIT_FIN_SUMMARY_TYPE_SO && (
          <div
            className="icon-btn"
            title="Generate Invoice"
            onClick={() => handleGenerateInvoice(cellProps)}
          >
            <img
              src="/static/icons/Generate_Invoice_Icon.png"
              alt="Generate Invoice"
              className="icon-img"
            />
          </div>
        )}

        {/* ✅ More Options Menu */}
        {props.pageMode &&
          props.pageMode !== PAGE_MODE.ALL_INVOICELIST &&
          org?.orgCode !== ORG_CODES.MANASWINI && (
            <div>
              <MoreOptionsMenu
                // onOptionSelect={handleSelectedMenuOption}
                itemsToShow={[
                  cellProps.data.isKpCash
                    ? BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CASH_KEY
                    : BILLING_VISIT_FINANCIAL_SUMMARY_MORE_MENU_OPTIONS.CONVERT_TO_CREDIT_KEY,
                ]}
                invoice={cellProps.data}
                visitInternalStatus={patientBasicInfo?.visit?.internalStatus}
                billingStatus={patientBasicInfo?.visit?.billingStatus}
                onClose={(e) => handleMoreOptionMenuClose(e)}
                disabled={isMenuMoreOptionDisable}
              />
            </div>
          )}
      </div>
    );
  };

  let currentRowHeight;

  const updateRowHeight = (params) => {
    // get the height of the grid body - this excludes the height of the headers
    const bodyViewport = document.querySelector(".ag-body-viewport");
    if (!bodyViewport) {
      return;
    }
    const gridHeight = bodyViewport.clientHeight;
    // get the rendered rows
    const renderedRowCount = params.api.getDisplayedRowCount();
    // if the rendered rows * min height is greater than available height, just just set the height
    // to the min and let the scrollbar do its thing
    if (renderedRowCount * AG_GRID_REACT_MIN_ROW_HEIGHT >= gridHeight) {
      if (currentRowHeight !== AG_GRID_REACT_MIN_ROW_HEIGHT) {
        currentRowHeight = AG_GRID_REACT_MIN_ROW_HEIGHT;
        params.api.resetRowHeights();
      }
    } else {
      // set the height of the row to the grid height / number of rows available
      currentRowHeight = Math.floor(gridHeight / renderedRowCount);
      params.api.resetRowHeights();
    }
  };

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  const containerStyle = useMemo(
    () => ({
      width: "100%",
      height: COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT.ERPVisitFinancialSummary,
    }),
    [],
  );
  // const gridStyle = useMemo(() => ({ alignItems: "start", height: "100%", width: "100%" }), []);
  const rowStyle = {
    background: "white",
    display: "flex",
    justifyContent: "center",
  };

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      //   minWidth: 100,
      filter: true,
      resizable: true,
      floatingFilter: true,
    };
  }, []);

  useEffect(() => {
    console.log("props data : ", props);
    let locationDetail = props.selectedLocationDetails;
    let patientId = props.patientId;
    let visitId = props.visitId;
    let totlAdvancePaid = props.totalAdvPaid;
    const { start: fromDate, end: toDate } = props.dateRange || {};
    // let searchQuery=props?.searchQuery;
    const { searchQuery } = extractFilters(props?.searchtags);

    console.log("From Date:", fromDate);
    console.log("To Date:", toDate);
    console.log("Search Query:", searchQuery);
    console.log("location details : ", locationDetail);
    let locationId = [];

    // Check if any element in selectedLocationDetail meets the condition
    const hasAllLocationKey = locationDetail?.some(
      (element) => element?.locationDetails && element?.locationKey === MASTER_LOCATION_DATA_LOCATION_KEY.ALL,
    );

    if (hasAllLocationKey) {
      // Execute the if clause when a matching element is found
      const matchingElement = locationDetail?.find(
        (element) => element?.locationKey === MASTER_LOCATION_DATA_LOCATION_KEY.ALL,
      );
      console.log("hasAllLocationKey",hasAllLocationKey,locationDetail);
      
      locationId = matchingElement?.locationDetails?.erpLocationDetails?.[0]?.locationid;
    } else {
      locationId = [
        ...new Set(
          locationDetail
            .filter(
              (element) =>
                element?.locationDetails?.erpLocationDetails?.[0]
                  ?.isBillingLocation,
            )
            .map(
              (element) =>
                element?.locationDetails?.erpLocationDetails?.[0]?.locationid,
            ),
        ),
      ];
    }

    // const erpCustId = [
    //   ...new Set(
    //     locationDetail
    //       ?.map((element) => element?.locationDetails?.erpLocationDetails?.[0]?.erpCustId)
    //       .filter((id) => (id !== undefined || id !== null)) // Remove undefined values
    //   ),][0] ?? null;

    const clientERPCustId =
      locationDetail
        ?.map((el) => el?.clientERPCustId)
        .find((id) => id != null) ?? null;

    setTotalAdvPaid(totlAdvancePaid);

    console.log(
      `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${selectedLocationDetail} `,
    );

    async function loadInvoices() {
      const result = await fetchInvoices({
        patientId,
        visitId,
        locationId,
        fromDate,
        toDate,
        searchQuery,
        clientERPCustId,
        totlAdvancePaid,
        props,
        masterLocationDetails,
        org,
      });

      // if (result && result.rowData) {
      //   setRowData(result.rowData);
      // }

      if (result && result.rowData) {
        const sortedData = [...result.rowData].sort((a, b) => {
          return b.ticketId - a.ticketId; // DESC order
        });

        setRowData(sortedData);
      }

      if (result && result.finSummary) {
        setTotalFinAmtSummary(result.finSummary);
      }
      console.log("loadinvoice: ", props, "\nresult: ", result);

      if (props.pageMode !== PAGE_MODE.ALL_INVOICELIST) {
        props.onFinancialUpdate(result.finSummary);
      }
      if (result.finSummary && "all" in result.finSummary) {
        let balAmt =
          result.finSummary["all"].totalBillAmount -
          result.finSummary["all"].totalSalesOrderAmt;
        balAmt = Math.round(balAmt).toFixed(2);
        setBalanceAmount(balAmt);
      } else {
        setBalanceAmount(0.0);
      }
    }
    if(locationId && locationId.length>0){
      loadInvoices();
    }
  }, [props.selectedLocationDetails, isReload]);

  useEffect(() => {
    setBalanceAmount(totalAdvPaid - totalBillAmt);
  }, [totalAdvPaid, totalBillAmt]);

  useEffect(() => {
    if (props.pageMode == PAGE_MODE.SINGLE_INVOICE) {
      setColumnDefs((prevColDefs) => {
        return prevColDefs.map((col) => {
          if (col.children) {
            // This is our balance column group
            return {
              ...col,
              headerName: `Balance ₹ ${balanceAmount}`,
              children: col.children,
            };
          }
          return col;
        });
      });
    }
  }, [balanceAmount]);

  useEffect(() => {
    console.log("rowdata in visit finacial summary",rowData);
    // const ticketIds = rowData.map((r) => r.ticketId).filter(Boolean);
    // props.onTicketIdsForPrint?.(ticketIds);

      if (!rowData?.length) return;

  // ✅ Only invoice ticketIds
  const invoiceTicketIds = rowData
    .filter(r => r.type === "INVOICE_LISTING")
    .map(r => r.ticketId)
    .filter(Boolean);

  // ✅ Full row data for advance + refund
  const advanceRefundRows = rowData.filter(
    r =>
      r.type === "ADVANCE_PAYMENTS" ||
      r.type === "REFUND_PAYMENTS"
  );

  console.log("Invoice TicketIds:", invoiceTicketIds);
  console.log("Advance/Refund Rows:", advanceRefundRows);

  // Send both separately to parent
  props.onPrintDataUpdate?.({
    invoiceTicketIds,
    advanceRefundRows
  });
  
  }, [rowData]);

  const extractFilters = (tagList) => {
    const textTag = tagList?.find((t) => t?.type === "text");
    const dateTag = tagList?.find((t) => t?.type === "date");

    return {
      searchQuery: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
    };
  };

  return (
    <>
      {/* <h1>Service List</h1> */}
      <div className="ms-1" style={containerStyle}>
        <div className="ag-theme-balham ag-style ag-header-left px-1 py-2 w-100 h-100">
          {/* style={gridStyle}> */}
          <AgGridReact
            // autoSizeStrategy={autoSizeStrategy}
            // getRowHeight={getRowHeight}
            // onGridReady={onGridReady}
            // onFirstDataRendered={onFirstDataRendered}
            // onGridSizeChanged={onGridSizeChanged}
            // theme={theme}
            rowData={rowData}
            // rowStyle={rowStyle}
            pagination={
              COMPONENT_WISE_AG_GRID_PAGINATION.ERPVisitFinancialSummary
            }
            paginationPageSize={
              COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPVisitFinancialSummary
            }
            columnDefs={columnDefs}
            // onFilterChanged={}
            // rowSelection="multiple"
            suppressRowClickSelection
            frameworkComponents={{ ActionRenderer: ActionRenderer }}
            defaultColDef={defaultColDef}
            // animateRows={true}
            // className='d-flex justify-content-center'
            context={{
              onRowClick: props.onRowClick,
              showMessageStrip: props.serverResposnes,
            }}
          />
        </div>
        {printdata && triggerAction && (
          <HeaderFooterComponent
            title="Invoice"
            data={printdata}
            triggerAction={triggerAction}
            onComplete={() => {
              setPrintData(""); // clear data
              setTriggerAction(""); // clear action
              console.log("Print action completed and state cleared.");
            }}
          />
        )}
      </div>
    </>
  );
}
